var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCostotusV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1098.78 242.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #ffc9fe;\n            }\n\n            .cls-2 {\n                fill: #fed7ff;\n            }\n\n            .cls-3 {\n                fill: #ffd213;\n            }\n\n            .cls-4 {\n                fill: #185f8d;\n            }\n\n            .cls-5 {\n                fill: #006634;\n            }\n\n            .cls-6 {\n                fill: #082947;\n            }\n\n            .cls-7 {\n                fill: #fff;\n            }\n\n            .cls-8 {\n                fill: #ffe67f;\n                stroke: #082947;\n                stroke-miterlimit: 10;\n                stroke-width: 7px;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.46,45a3.88,3.88,0,0,1-5.88-.47,4.11,4.11,0,0,1,.5-5.09l11-11h-20L49.44,67.05h20L86.05,50.44a3.87,3.87,0,0,1,5.79.36A4,4,0,0,1,91.41,56l-11,11h66.09V28.37H119.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.88 28.36 28.88 67.05 38.88 67.05 77.56 28.36 28.88 28.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.23,
    y: 116.04,
    width: 24.24,
    height: 7.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 75.3,
    y: 146.98,
    width: 23.72,
    height: 22.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.37,
    y: 146.98,
    width: 23.72,
    height: 22.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 75.3,
    y: 191.85,
    width: 23.72,
    height: 22.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.37,
    y: 191.85,
    width: 23.72,
    height: 22.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156,7.74H19.34a11.6,11.6,0,0,0-11.6,11.6V223.05a11.6,11.6,0,0,0,11.6,11.61H156a11.6,11.6,0,0,0,11.6-11.61V19.34A11.6,11.6,0,0,0,156,7.74Zm-100,214H24.5a3.86,3.86,0,0,1-3.87-3.86V188a3.86,3.86,0,0,1,3.87-3.86H56A3.86,3.86,0,0,1,59.82,188V217.9A3.86,3.86,0,0,1,56,221.76Zm0-44.86H24.5A3.87,3.87,0,0,1,20.63,173V143.12a3.87,3.87,0,0,1,3.87-3.87H56a3.86,3.86,0,0,1,3.86,3.87V173A3.87,3.87,0,0,1,56,176.9Zm.12-81.49H25A4,4,0,0,1,21,92a3.87,3.87,0,0,1,3.84-4.36H55.94a4,4,0,0,1,4,3.39A3.86,3.86,0,0,1,56.08,95.41Zm46.81,126.35H71.43a3.86,3.86,0,0,1-3.87-3.86V188a3.86,3.86,0,0,1,3.87-3.86h31.46a3.87,3.87,0,0,1,3.87,3.86V217.9A3.87,3.87,0,0,1,102.89,221.76Zm0-44.86H71.43A3.87,3.87,0,0,1,67.56,173V143.12a3.87,3.87,0,0,1,3.87-3.87h31.46a3.87,3.87,0,0,1,3.87,3.87V173A3.88,3.88,0,0,1,102.89,176.9Zm47.45-45.39h-32a3.87,3.87,0,0,1-3.87-3.87V112.17a3.87,3.87,0,0,1,3.87-3.87h32a3.87,3.87,0,0,1,3.86,3.87v15.47A3.86,3.86,0,0,1,150.34,131.51Zm.25-36.1H71.7a4,4,0,0,1-4-3.38,3.87,3.87,0,0,1,3.83-4.36h78.89a4,4,0,0,1,4,3.39A3.87,3.87,0,0,1,150.59,95.41Zm.26-20.63H25a3.86,3.86,0,0,1-3.86-3.87V24.5A3.86,3.86,0,0,1,25,20.63H150.85a3.87,3.87,0,0,1,3.87,3.87V70.91A3.87,3.87,0,0,1,150.85,74.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.34,108.3h-32a3.87,3.87,0,0,0-3.87,3.87v15.47a3.87,3.87,0,0,0,3.87,3.87h32a3.86,3.86,0,0,0,3.86-3.87V112.17A3.87,3.87,0,0,0,150.34,108.3Zm-3.87,15.48H122.23V116h24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56,184.12H24.5A3.86,3.86,0,0,0,20.63,188V217.9a3.86,3.86,0,0,0,3.87,3.86H56a3.86,3.86,0,0,0,3.86-3.86V188A3.86,3.86,0,0,0,56,184.12ZM52.09,214H28.37V191.85H52.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.89,184.12H71.43A3.86,3.86,0,0,0,67.56,188V217.9a3.86,3.86,0,0,0,3.87,3.86h31.46a3.87,3.87,0,0,0,3.87-3.86V188A3.87,3.87,0,0,0,102.89,184.12ZM99,214H75.3V191.85H99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56,139.25H24.5a3.87,3.87,0,0,0-3.87,3.87V173a3.87,3.87,0,0,0,3.87,3.87H56A3.87,3.87,0,0,0,59.82,173V143.12A3.86,3.86,0,0,0,56,139.25Zm-3.87,29.91H28.37V147H52.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.89,139.25H71.43a3.87,3.87,0,0,0-3.87,3.87V173a3.87,3.87,0,0,0,3.87,3.87h31.46a3.88,3.88,0,0,0,3.87-3.87V143.12A3.87,3.87,0,0,0,102.89,139.25ZM99,169.16H75.3V147H99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156,0H19.34A19.34,19.34,0,0,0,0,19.34V223.05a19.34,19.34,0,0,0,19.34,19.34H156a19.34,19.34,0,0,0,19.34-19.34V19.34A19.34,19.34,0,0,0,156,0Zm0,234.66H19.34a11.6,11.6,0,0,1-11.6-11.61V19.34a11.6,11.6,0,0,1,11.6-11.6H156a11.6,11.6,0,0,1,11.6,11.6V223.05A11.6,11.6,0,0,1,156,234.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "79.49 28.36 40.81 67.05 51.75 67.05 90.43 28.36 79.49 28.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.3,45A3.85,3.85,0,0,0,102,46.1,3.81,3.81,0,0,0,104.77,45l16.61-16.6H110.44L99.3,39.5A3.87,3.87,0,0,0,99.3,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.83,50.44a3.87,3.87,0,0,0-5.47,0L71.76,67.05H82.7L93.83,55.91A3.87,3.87,0,0,0,93.83,50.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.85,20.63H25a3.86,3.86,0,0,0-3.86,3.87V70.91A3.86,3.86,0,0,0,25,74.78H150.85a3.87,3.87,0,0,0,3.87-3.87V24.5A3.87,3.87,0,0,0,150.85,20.63ZM147,67.05H28.88V28.37H147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.59,87.67H71.7a4,4,0,0,0-4,3.39,3.86,3.86,0,0,0,3.83,4.35h78.89a4,4,0,0,0,4-3.38A3.87,3.87,0,0,0,150.59,87.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.08,87.67H25a4,4,0,0,0-4,3.39,3.87,3.87,0,0,0,3.84,4.35H55.94a4,4,0,0,0,4-3.38A3.87,3.87,0,0,0,56.08,87.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 122.74,
    y: 146.98,
    width: 23.72,
    height: 67.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.35,139.25H118.86c-2.13,0-3.85,3.82-3.85,8.53v65.45c0,4.71,1.72,8.53,3.85,8.53h31.49c2.13,0,3.85-3.82,3.85-8.53V147.78C154.2,143.07,152.48,139.25,150.35,139.25ZM146.47,214H122.74V147h23.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M283.61,78V40.84H256V200.56h27.59V102.41l33.1,19.16v112.1h-93.8V7.74h93.8V78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M427.94,40.84V233.67h-93.8V7.74h93.8ZM394.83,200.56V40.84H367.24V200.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M539.16,7.74V78.3H506.05V40.84H478.47v45.6l60.69,35.13v112.1h-93.8V145.1h33.11v55.46h27.58v-56h10.17l-.58-.29-9.59-5.52-60.69-35.14V7.74h93.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M650.38,40.84H619.89V233.67h-33.1V40.84H556.58V7.74h93.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M761.61,40.84V233.67h-93.8V7.74h93.8ZM728.5,200.56V40.84H700.91V200.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M872.83,40.84H842.34V233.67H809.23V40.84H779V7.74h93.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M984.05,233.67h-93.8V7.74h33.11V200.56H951V7.74h33.1V233.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1095.28,7.74V78.3h-33.11V40.84h-27.59v45.6l60.7,35.13v112.1h-93.8V145.1h33.1v55.46h27.59v-56h10.17l-.58-.29-9.59-5.52-60.69-35.14V7.74h93.8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostotusV2);
export default __webpack_public_path__ + "static/media/costotus-v2.6dbeb182169e6a38ae2640cdb99cdfb8.svg";
export { ForwardRef as ReactComponent };